import { render, staticRenderFns } from "./DataMatrixReader.vue?vue&type=template&id=160a3499&scoped=true&"
import script from "./DataMatrixReader.vue?vue&type=script&lang=js&"
export * from "./DataMatrixReader.vue?vue&type=script&lang=js&"
import style0 from "./DataMatrixReader.vue?vue&type=style&index=0&id=160a3499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a3499",
  null
  
)

export default component.exports